// extracted by mini-css-extract-plugin
export var euProgram = "eu-program-2-module--eu-program--CjoiL";